import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=06b2f6a0&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=06b2f6a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2f6a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b2f6a0')) {
      api.createRecord('06b2f6a0', component.options)
    } else {
      api.reload('06b2f6a0', component.options)
    }
    module.hot.accept("./submit.vue?vue&type=template&id=06b2f6a0&scoped=true&", function () {
      api.rerender('06b2f6a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/user/components/submit.vue"
export default component.exports